<template>
	<div class="search-field">
		<div class="field">
			<div class="control has-icons-left has-icons-right">
				<input
					type="text"
					class="input is-small search"
					v-model="searchValue"
					@keyup.enter="search"
					@keyup.esc="clearSearch"
					:placeholder="$t('searchbar.search') + ' ' + placeholder"
				/>
				<span class="icon is-left search">
					<i class="fas fa-search"></i>
				</span>
				<span class="icon is-right clear" @click="clearSearch">
					<i class="fas fa-times"></i>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		placeholder: String
	},
	data() {
		return {
			searchValue: ''
		};
	},
	methods: {
		clearSearch() {
			this.searchValue = '';
			this.search();
		},
		search() {
			this.$emit('search', this.searchValue);
		}
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/colors.scss";
.control {
  .input.is-small.search {
    background-color: $search-background;
    border-color: $search-border;
    border-radius: 15px;
    color: $search-color;
  }
  .icon.clear {
    pointer-events: initial;
    cursor: pointer;
  }
}
</style>
